import React, { useState, useEffect } from "react";
import Header from "../../Home/Header/Header";
import "./SampleReport.scss";
import ledgerData from "./ledgerData.json";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const SampleReport = () => {
  const [filter, setFilter] = useState("All Groups");
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();

  const filters = ["All Groups", "B2B", "B2C", "Branch"];

  useEffect(() => {
    if (filter === "All Groups") {
      setFilteredData(ledgerData);
    } else {
      setFilteredData(ledgerData.filter((item) => item.category === filter));
    }
  }, [filter]);

  const handleClick = (entry) => {
    navigate(`/LedgerDetail`, { state: entry });
  };

  return (
    <div>
      <Header otherPage={true} title="Ledgers" />
      <div className="ledger-container">
        <div className="filter-dropdown">
          <FormControl fullWidth size="small" style={{ margin: "10px 0" }}>
            <InputLabel>Filter</InputLabel>
            <Select
              value={filter}
              label="Filter"
              onChange={(e) => setFilter(e.target.value)}
            >
              {filters?.map((f, idx) => (
                <MenuItem key={idx} value={f}>
                  {f}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        <div className="ledger-list">
          {filteredData.map((entry, index) => (
            <Button
              key={index}
              className="ledger-item"
              onClick={() => handleClick(entry)}
            >
              <span className="company-name">{entry.companyName}</span>
              <span className="ledger-symbol">{entry.symbol}</span>
              <span className="event-count">({entry.eventCounts})</span>
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SampleReport;
